<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import { dateFormat } from "@/core/services/helpers"
  import { ptBR } from "vuejs-datepicker/dist/locale"
  import SectionPointForm from "@/domains/lines/views/sectionPoints/partials/SectionPointForm.vue"

  export default {
    components: {
      Breadcrumbs,
      SectionPointForm,
    },
    props: {
      isModal: {
        type: Boolean,
        default: false,
      },
    },
    data: () => {
      return {
        locale: ptBR,
        dateFormat,
        title: "Novo Ponto de seção",
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Linhas", path: "lines.index" },
          {
            name: "Pontos de seção",
            path: "lines.sectionpoints",
          },
          {
            name: "Novo Ponto de seção",
            path: "lines.sectionpoints.create",
          },
        ],
        sectionPoint: {
          nmlocalidade: "",
          delocalidade: "",
          numunicipio: null,
          gelat: "",
          gelng: "",
          flsituacao: 1,
        },
      }
    },
    methods: {
      submit() {
        this.$axios
          .post("/api/lines/section-point", this.sectionPoint)
          .then((response) => {
            this.$toast.success({
              title: "OK",
              message: "Ponto de Seção Cadastrado com Sucesso",
            })
            if (this.isModal) {
              // Emite evento com os dados do ponto criado
              this.$emit("created", response.data)
            } else {
              // Redireciona apenas se não for modal
              this.$router.push({ name: "lines.sectionpoints" })
            }
          })
          .catch((error) => {
            this.$toast.error({
              title: "Erro",
              message: error.response.data.error,
            })
          })
      },
      cancel() {
        if (this.isModal) {
          // Emite evento de cancelamento
          this.$emit("cancel")
        } else {
          // Volta para a página anterior
          this.$router.go(-1)
        }
      },
    },
  }
</script>

<template>
  <div class="w-full bg-white">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-2" :crumbs="crumbs" v-if="!isModal"/>
      <div
        class="flex flex-wrap justify-between align-baseline border-b-2 border-green-base mb-2"
        v-if="!isModal"
      >
        <h1 class="text-green-base uppercase pt-5">
          Cadastro de Ponto de Seção
        </h1>
      </div>
      <SectionPointForm
        :sectionPoint="sectionPoint"
        @submit="submit"
        @cancel="cancel"
        :isModal="isModal"
      />
    </div>
  </div>
</template>
